import { ACHIEVEMENTS } from "../constants/achievement";
import {
  AchievementType,
  AchievementUserNotificationData,
  FollowUserNotificationData,
  LeaderboardUserNotificationData,
  UserNotification,
  UserNotificationType,
} from "@onmo/graphql/graphql";

const Leaderboard_Type = {
  GLB_WEEKLY: "global-leaderboard-weekly",
  GLB_MONTHLY: "global-leaderboard-monthly",
};

export const NotificationTypeInTGP = [
  UserNotificationType.FollowedByUser,
  UserNotificationType.AchievementReward,
  UserNotificationType.GlobalLeaderboardEnded,
];

const getAchievementNameByType = (type: AchievementType) => {
  switch (type) {
    case AchievementType.BattlesWon:
      return "Conqueror";
    case AchievementType.BattleStreak:
      return "Unstoppable";
    case AchievementType.Challenger:
      return "Challenger";
    case AchievementType.Completionist:
      return "Mastery";
    case AchievementType.TournamentsParticipation:
      return "Gladiator";
    case AchievementType.BattleFriendsPlayed:
      return "Showdown";
    case AchievementType.WeeklyGlParticipant:
      return "Contender";
    case AchievementType.WeeklyGlWinner:
      return "Dominator";
    case AchievementType.Followers:
      return "Influencer";
    default:
      return "Achievement";
  }
};

const getAchievementIconsFromIdAndTier = (id: string, tier: number) => {
  const achievement = ACHIEVEMENTS.find((a) => a.id === id);
  if (!achievement) return null;

  return achievement.icons[tier];
};

const getContent = (notification: UserNotification) => {
  if (!notification) return;
  switch (notification?.type) {
    case UserNotificationType.FollowedByUser:
      return {
        title: "New Follower",
        message: (notification?.data as FollowUserNotificationData)
          ?.followerUser?.username,
      };
    case UserNotificationType.AchievementReward: {
      const achievementName = NotificationMd.getAchievementNameByType(
        (notification.data as AchievementUserNotificationData).type,
      );
      return {
        title: "New Achievement",
        message: achievementName,
      };
    }
    case UserNotificationType.GlobalLeaderboardEnded: {
      const lbData = notification.data as LeaderboardUserNotificationData;
      if (lbData.leaderboardType === Leaderboard_Type.GLB_WEEKLY) {
        return {
          title: "Weekly Leaderboard",
          message: `#${lbData.rank}`,
        };
      } else if (lbData.leaderboardType === Leaderboard_Type.GLB_MONTHLY) {
        return {
          title: "Monthly Leaderboard",
          message: `#${lbData.rank}`,
        };
      }
    }
  }
};

const filterNotificationType = (notification?: UserNotification[]) => {
  if (!notification) return [];

  const res = notification.filter((item) => {
    return NotificationTypeInTGP.includes(item.type);
  });

  return res;
};

export const NotificationMd = {
  getAchievementNameByType,
  getAchievementIconsFromIdAndTier,
  getContent,
  filterNotificationType,
};
